import * as React from 'react'

import { Body, BodyContent, BodyHeader, Footer, FooterLink, Header, MenuSide } from '../components/layout'
import { get } from 'unno-comutils'
import { useEffect, useState } from 'react'

Privacy_cookie.getInitialProps = async (props: any) => {
    return {
        data: await get('web/content/privacy/11').then((d: any) => d.data)
    }
}

export default function Privacy_cookie (props: any) {

    const [data, setData] = useState<any>(null)

    useEffect(() => {
        setData(props.data)
    }, [])

    return <>
        <Header/>
        <Body flex>
            <MenuSide/>
            <BodyContent>
                <BodyHeader>นโยบายส่วนบุคคลเกี่ยวกับ cookie</BodyHeader>
                {data && <div className={'privacy-content'} dangerouslySetInnerHTML={{ __html: data.content }}/>}
            </BodyContent>
        </Body>
        <Footer/>
        <FooterLink/>
    </>
}
